import { render, staticRenderFns } from "./FollowupSettings.vue?vue&type=template&id=58f57f3a&scoped=true"
import script from "./FollowupSettings.vue?vue&type=script&lang=js"
export * from "./FollowupSettings.vue?vue&type=script&lang=js"
import style0 from "./FollowupSettings.vue?vue&type=style&index=0&id=58f57f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f57f3a",
  null
  
)

export default component.exports